import { useRef } from 'react';

import { Timeout } from 'utils';

export const useTimeout = () => {
	const timeout = useRef(new Timeout());

	return timeout.current;
};
